export default function getLicenseTypeClass(licenseType) {
    return {
        'badge badge-primary' : licenseType === 'LICENSE_RESELLER',
        'badge badge-light'   : licenseType === 'LICENSE_DEFAULT'
    }
}